import type { z } from 'zod'
import { idSchemaV2, isId } from '../../ids'

export const ComplianceViolationIdSchema = idSchemaV2('CViolation')
export type ComplianceViolationId = z.infer<typeof ComplianceViolationIdSchema>
export const isComplianceViolationId = isId(ComplianceViolationIdSchema)
